export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/bike/index/resources/computed.js